export const tabs = {
    table: '#tab=table',
    charts: '#tab=charts'
};
